export function setInvoices(state, payload) {
  state.invoices = payload;
}

export function setIsPaymentArrangementsDisabled(state, payload) {
  state.isPaymentArrangementsDisabled = payload;
}

export function setIsLoadingInvoices(state, payload) {
  state.isLoadingInvoices = payload;
}

export function setPaymentArrangements(state, payload) {
  state.paymentArrangements = payload;
}

export function setIsLoadingPaymentArrangements(state, payload) {
  state.isLoadingPaymentArrangements = payload;
}

export function addAttachmentToInvoice(state, payload) {
  state.invoices.find((x) => x.invoiceNumber === payload.invoiceNumber).attachments.unshift(...payload.attachments);
  state.invoiceAttachmentIdsFetched.push(payload.invoiceNumber);
}

export function setIsLoadingAttachments(state, payload) {
  state.isLoadingAttachments = payload;
}

export function setHasUnproccessedPaymentArrangments(state, payload) {
  state.hasUnproccessedPaymentArrangments = payload;
}
